import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import GenericPage from '../../components/GenericPage';
import {
    fetchReportjobordercustomerlocations,
    createReportjobordercustomerlocation,
    updateReportjobordercustomerlocation,
    deleteReportjobordercustomerlocation,
    downloadReportjobordercustomerlocation,
    setPagination,
    setSort,
    searchReportjobordercustomerlocations,
    setDefaultFilter,
    changeCondition,
    addNewCondition,
    updateOptionRule,
    updateOptionValue,
    removeCondition,
    saveFilterCondition,
    setSelected,
    resetFiltersAndPagination,

    changeClassicFilter
} from '../../store/modules/reportjobordercustomerlocation/reportjobordercustomerlocationActions';
import ReportjobordercustomerlocationForm from '../../components/pageModule/Reportjobordercustomerlocations/ReportjobordercustomerlocationForm';

const MySwal = withReactContent(Swal);

const Reportjobordercustomerlocations = ({
    excludedActions = [],
    onSelectedRowsChange = () => { },
    onClickedRow = () => { },
    externalCondition = {},
    selectedIds = []
}) => {

    const reportjobordercustomerlocationState = useSelector(state => state.reportjobordercustomerlocation);
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(resetFiltersAndPagination());
        };
    }, []);

    const handleCreate = async (formData) => {
        try {
            const response = await dispatch(createReportjobordercustomerlocation(formData));
            toast.success('Reportjobordercustomerlocation created successfully', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            return response;
        } catch (error) {
            toast.error(error.message || 'Error creating reportjobordercustomerlocation', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const handleUpdate = async (id, formData) => {
        try {
            const response = await dispatch(updateReportjobordercustomerlocation(id, formData));
            toast.success('Reportjobordercustomerlocation updated successfully', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            return response;
        } catch (error) {
            toast.error(error.message || 'Error updating reportjobordercustomerlocation', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const handleDelete = async (id) => {
        const result = await MySwal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true
        });

        if (result.isConfirmed) {
            try {
                await dispatch(deleteReportjobordercustomerlocation(id));
                toast.success('Reportjobordercustomerlocation deleted successfully', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                return true;
            } catch (error) {
                toast.error(error.message || 'Error deleting reportjobordercustomerlocation', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                return false;
            }
        }
        return false;
    };

    const handleDownload = async (type) => {
        try {
            const response = await dispatch(downloadReportjobordercustomerlocation(type));
            window.open(response.url, '_blank')
            return response;
        } catch (error) {
            toast.error(error.message || 'Error downloading reportjobordercustomerlocations', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    };

    const columns = [
        {
            name: 'Job Order',
            selector: row => row.order_number ?? '-',
        },
        {
            name: 'Order Date',
            selector: row => row.order_date ?? '-',
        },
        {
            name: 'Customer Name',
            selector: row => row.customer_name ?? '-',
        },
        {
            name: 'Gross Total',
            selector: row => row.gross_total ?? '-',
        },
        {
            name: 'Net Total',
            selector: row => row.net_total ?? '-',
        },
        {
            name: 'Item Code',
            selector: row => row.item_code ?? '-',
        },
        {
            name: 'Item Name',
            selector: row => row.item_name?.en ?? row.item_name?.ar ?? '-',
        },
        {
            name: 'Unit',
            selector: row => row.unit ?? '-',
        },
        {
            name: 'Quantity',
            selector: row => row.quantity ?? '-',
        },
        {
            name: 'Unit Price',
            selector: row => row.unit_price ?? '-',
        },
        {
            name: 'Line Amount',
            selector: row => row.line_amount ?? '-',
        },
    ];


    const actions = {
        fetch: (queryFilter, activeFilter, shouldUseFilter, externalCondition) => dispatch(fetchReportjobordercustomerlocations(queryFilter, activeFilter, shouldUseFilter, externalCondition)),
        create: handleCreate,
        update: handleUpdate,
        delete: handleDelete,
        download: handleDownload,
        search: (search) => dispatch(searchReportjobordercustomerlocations(search)),
        setPagination: (pagination) => dispatch(setPagination(pagination)),
        setSort: (sort) => dispatch(setSort(sort)),
        setDefaultFilter: (filter) => dispatch(setDefaultFilter(filter)),
        changeCondition: (index, condition) => dispatch(changeCondition(index, condition)),
        addNewCondition: (rule) => dispatch(addNewCondition(rule)),
        updateOptionRule: (index, rule) => dispatch(updateOptionRule(index, rule)),
        updateOptionValue: (index, value) => dispatch(updateOptionValue(index, value)),
        removeCondition: (index) => dispatch(removeCondition(index)),
        saveFilterCondition: (filter) => dispatch(saveFilterCondition(filter)),
        setSelected: (selectedRows) => dispatch(setSelected(selectedRows)),

        onClassicFilterChange: (name, value) => dispatch(changeClassicFilter(name, value)),
    };

    const defaultAvailableActions = ['export_pdf', 'export_excel'];
    const availableActions = defaultAvailableActions.filter(action => !excludedActions.includes(action));

    return (
        <>
            <GenericPage
                title="Report Job Order Register by Customer Location"
                moduleName="Reportjobordercustomerlocation"
                moduleKey="reportjobordercustomerlocations"
                state={reportjobordercustomerlocationState}
                actions={actions}
                FormComponent={ReportjobordercustomerlocationForm}
                columns={columns}
                availableActions={availableActions}
                actionsColumnWidth="150px"
                selectableRows={false}
                onSelectedRowsChange={onSelectedRowsChange}
                onClickedRow={onClickedRow}
                selectedIds={selectedIds}
                externalCondition={externalCondition}
            />
        </>
    );
};

export default Reportjobordercustomerlocations; 